import { getQFromQuery } from '../../utils'
import { ClusteringKMeansSettingsQueryParams } from '../types'

export const generateQuery = ({ geomField, clusters, baseQuery }: ClusteringKMeansSettingsQueryParams) => {
  const lastQuery = getQFromQuery(baseQuery) || 1
  const clusteringQquery = `\tSELECT
\t\tCAST(ST_ClusterKMeans(${geomField}, ${clusters}) OVER() AS TEXT) AS cluster,
\t\t${geomField}
\tFROM
\t\t__q${lastQuery}
\tWHERE
\t\t${geomField} IS NOT NULL`
  const query = `${baseQuery},
__q${lastQuery + 1} AS (
${clusteringQquery}
)
SELECT * FROM __q${lastQuery + 1}`
  return query
}
